import { assign } from 'xstate5';

import { type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const clearGroupOrderReorderRequest: ReorderMachineAction = assign(() => ({
  groupOrderReorderRequest: undefined,
}));
